<template>
  <!-- ref="dialogRef" ссылается на переменную из setup -->
  <q-dialog
    ref="dialogRef"
    persistent no-shake
    :full-width="!isMobile"
    :maximized="isMobile"
    @hide="onDialogHide"
  >
    <item-addition-component
      :existing-position-id="existingPositionId"
      @close="handleClose"
    />
  </q-dialog>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-facing-decorator'
import { useDialogPluginComponent } from 'quasar'
import ItemAdditionComponent from '../ItemAdditionComponent.vue'
import { useBreakpoints } from '@/composables/useBreakpoints'

@Component({
  components: { ItemAdditionComponent },
  emits: [...useDialogPluginComponent.emits],
  // Хук диалога инициализируем в setup, чтобы dialogRef и onDialog* были доступны экземпляру
  setup() {
    const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()
    const { isMobile } = useBreakpoints()
    return {
      dialogRef,
      onDialogHide,
      onDialogOK,
      onDialogCancel,
      isMobile
    }
  }
})
export default class ItemInfoDialog extends Vue {
  @Prop({ required: true }) existingPositionId!: number

  // Приходят из setup()
  declare dialogRef: any
  declare onDialogHide: () => void
  declare onDialogOK: (payload?: any) => void

  handleClose() {
    this.onDialogOK()
  }
}
</script>
